import { render, staticRenderFns } from "./CargoQuoteList.vue?vue&type=template&id=26a69f26&"
import script from "./CargoQuoteList.vue?vue&type=script&lang=js&"
export * from "./CargoQuoteList.vue?vue&type=script&lang=js&"
import style0 from "./CargoQuoteList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoQuoteList.vue"
export default component.exports